import { render, staticRenderFns } from "./UserViewInfoCard.vue?vue&type=template&id=70a6f40d"
import script from "./UserViewInfoCard.vue?vue&type=script&lang=js"
export * from "./UserViewInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports